import * as React from 'react';

import {serializeFilters} from 'nutshell-core';

import {formEncodedApi} from 'nutshell-core/api';
import type {CoreEntityType, FilterObject, User} from 'nutshell-core/types';
import {getMultipleEntityType} from 'nutshell-core/utils/get-multiple-entity-type';

import type {ListOptionWithCount} from 'shells/select-option-components/option-with-count';

import {GetSessionUser} from '../../core/get-session-user';

import {ActionsAccount} from './actions-account';
import {ActionsAudience} from './actions-audience';
import {ActionsContact} from './actions-contact';
import {ActionsLead} from './actions-lead';

import styles from './actions.module.css';

type Props = {
    query: {
        filter: {
            selected: FilterObject[];
        };
        search: {
            selected: string;
        };
    };
    entityType: CoreEntityType;
    entityData: {
        string: {
            id: string;
            primaryName: string;
        };
    };
    displayName: string;
    displayNameSingular: string;
    filters: any[];
    search?: string;
    massSelect: boolean;
    selectedCount: number;
    omittedCount: number;
    maxMergeCount: number;
    allItems: any[];
    selectedItems: string[];
    omittedItems: string[];
    user?: User | null | undefined;
    onEdit: () => void;
    onExportToMailChimp: () => void;
    onExportToConstantContact: () => void;
    onAddToAudience: () => void;
    onMerge: () => void;
    onMergeLeads: () => void;
    onDelete: () => void;
    audienceId?: string;
};

type State = {
    action?: React.ReactNode;
};

export class FooterActions extends React.Component<Props, State> {
    merge: HTMLElement | null | undefined;

    constructor(props: Props) {
        super(props);
        this.state = {
            action: undefined,
        };
    }

    componentDidMount() {
        document.addEventListener('bulkEditDidApply', this.props.onEdit, false);
        $('body').on('click', '.action-export-mailchimp', this.handleExportToMailChimp);
    }

    componentWillUnmount() {
        // @ts-expect-error
        $('body').off('click', '.action-export-mailchimp', this.handleExportToMailChimp);
        document.removeEventListener('bulkEditDidApply', this.props.onEdit);
    }

    render() {
        return (
            <GetSessionUser>
                {({user: sessionUser}) => {
                    const {
                        user,
                        entityType,
                        massSelect,
                        maxMergeCount,
                        omittedCount,
                        selectedCount,
                    } = this.props;

                    const canAccessCrm = Boolean(
                        sessionUser && sessionUser.permissions.canAccessCrm
                    );

                    return (
                        <div className={styles.buttons}>
                            {entityType === 'contacts' && !this.props.audienceId && user && (
                                <ActionsContact
                                    filters={this.props.filters}
                                    massSelect={massSelect}
                                    selectedCount={selectedCount}
                                    allItems={this.props.allItems}
                                    selectedItems={this.props.selectedItems}
                                    omittedItems={this.props.omittedItems}
                                    canAccessCrm={canAccessCrm}
                                    entityData={this.props.entityData}
                                    handleAddToAudienceSubmit={this.handleAddToAudienceSubmit}
                                    handleEditClick={this.handleEditClick}
                                    handleSyncToWebfxSubmit={this.handleSyncToWebfxSubmit}
                                    maxMergeCount={maxMergeCount}
                                    omittedCount={omittedCount}
                                    q={this.props.search || ''}
                                    user={user}
                                    displayName={this.props.displayName}
                                    displayNameSingular={this.props.displayNameSingular}
                                    onExportToConstantContact={this.props.onExportToConstantContact}
                                    handleConstantContactSubmit={this.handleConstantContactSubmit}
                                    handleDelete={this.props.onDelete}
                                    onMerge={this.props.onMerge}
                                    onMergeLeads={this.props.onMergeLeads}
                                />
                            )}
                            {entityType === 'contacts' && this.props.audienceId && user && (
                                <ActionsAudience
                                    audienceId={this.props.audienceId}
                                    selectedCount={selectedCount}
                                    onAddToAudience={this.handleAddToAudienceSubmit}
                                    onRemoveFromAudience={this.handleRemoveFromAudienceSubmit}
                                    canBulkEdit={canAccessCrm}
                                    onEdit={this.handleEditClick}
                                />
                            )}
                            {entityType === 'accounts' && user && (
                                <ActionsAccount
                                    filters={this.props.filters}
                                    massSelect={massSelect}
                                    selectedCount={selectedCount}
                                    allItems={this.props.allItems}
                                    selectedItems={this.props.selectedItems}
                                    omittedItems={this.props.omittedItems}
                                    canAccessCrm={canAccessCrm}
                                    entityData={this.props.entityData}
                                    handleAddToAudienceSubmit={this.handleAddToAudienceSubmit}
                                    handleEditClick={this.handleEditClick}
                                    maxMergeCount={maxMergeCount}
                                    omittedCount={omittedCount}
                                    q={this.props.search || ''}
                                    user={user}
                                    displayName={this.props.displayName}
                                    displayNameSingular={this.props.displayNameSingular}
                                    onExportToConstantContact={this.props.onExportToConstantContact}
                                    handleConstantContactSubmit={this.handleConstantContactSubmit}
                                    handleDelete={this.props.onDelete}
                                    onMerge={this.props.onMerge}
                                    onMergeLeads={this.props.onMergeLeads}
                                />
                            )}
                            {entityType === 'leads' && user && (
                                <ActionsLead
                                    user={user}
                                    filters={this.props.filters}
                                    massSelect={massSelect}
                                    selectedCount={selectedCount}
                                    handleAddToAudienceSubmit={this.handleAddToAudienceSubmit}
                                    handleEditClick={this.handleEditClick}
                                    handleSyncToWebfxSubmit={this.handleSyncToWebfxSubmit}
                                    maxMergeCount={maxMergeCount}
                                    omittedCount={omittedCount}
                                    selectedItems={this.props.selectedItems}
                                    displayName={this.props.displayName}
                                    displayNameSingular={this.props.displayNameSingular}
                                    onExportToConstantContact={this.props.onExportToConstantContact}
                                    handleConstantContactSubmit={this.handleConstantContactSubmit}
                                    handleDelete={this.props.onDelete}
                                    onMerge={this.props.onMerge}
                                    onMergeLeads={this.props.onMergeLeads}
                                    allItems={this.props.allItems}
                                />
                            )}
                            {this.state.action}
                        </div>
                    );
                }}
            </GetSessionUser>
        );
    }

    handleEditClick = () => {
        let url = '/bulk-edit-lead';
        if (this.props.entityType === 'accounts') url = '/bulk-edit-company';
        if (this.props.entityType === 'contacts') url = '/bulk-edit-person';

        const urlData: Record<string, any> = {};
        urlData.newFilters = true;
        if (this.props.massSelect) {
            urlData.filter = serializeFilters(this.props.filters);
            urlData.q = this.props.search;
            urlData.omittedItems = this.props.omittedItems;
        } else {
            urlData.selectedIds = this.props.selectedItems;
        }

        const eventProps = {
            numSelected: this.props.massSelect ? 'all' : this.props.selectedItems.length,
        } as const;

        Analytics.trackEvent(
            Analytics.categories.filtering,
            Analytics.actions.filtering.didPerformEditAction,
            eventProps
        );

        Modal.open({
            url,
            urlData,
            classNames: 'ui-modal__bulk-edit',
        });
    };

    handleConstantContactSubmit = (data: {
        listId: string | null | undefined;
        listName: string | null | undefined;
    }) => {
        const {entityType, massSelect, selectedItems, omittedItems, filters, search} = this.props;

        const defaultParams = {
            target: 'ConstantContact',
            listId: data.listId,
            listName: data.listName,
        } as const;

        // create an unsealed object for flow
        const postData: Record<string, any> = {};

        if (massSelect) {
            Object.assign(postData, defaultParams, {
                filter: serializeFilters(filters),
                q: search,
                omittedItems: omittedItems,
            });
        } else {
            Object.assign(postData, defaultParams, {selectedItems});
        }

        return formEncodedApi
            .post(`/${getMultipleEntityType(entityType)}/export`, postData)
            .catch(() => {
                throw new Error('Something went wrong. Not everyone was sent to Constant Contact');
            });
    };

    handleAddToAudienceSubmit = (audience: ListOptionWithCount, onlyPrimaryContact: boolean) => {
        const {massSelect, selectedItems, omittedItems, filters, search} = this.props;

        const defaultParams = {
            newFilters: true,
            audienceId: audience.value,
            onlyAddPrimaryContactToAudience: onlyPrimaryContact,
        } as const;

        // create an unsealed object for flow
        let postData: Record<string, any> = {};

        if (massSelect) {
            postData = {
                ...defaultParams,
                filter: serializeFilters(filters),
                q: search,
                omittedItems: omittedItems,
            };
        } else {
            postData = {
                ...defaultParams,
                selectedIds: selectedItems,
            };
        }

        let url = '/bulk-edit-lead/apply.json';
        if (this.props.entityType === 'accounts') url = '/bulk-edit-company/apply.json';
        if (this.props.entityType === 'contacts') url = '/bulk-edit-person/apply.json';

        return formEncodedApi
            .post(url, postData)
            .catch(() => {
                throw new Error(
                    `Something went wrong. Not everyone was added to the '${audience.label}' audience`
                );
            })
            .then(() => {
                this.props.onAddToAudience();
            });
    };

    handleRemoveFromAudienceSubmit = (audienceId: string) => {
        const postData = {
            newFilters: true,
            removeAudienceIds: [audienceId],
            selectedIds: this.props.selectedItems,
        } as const;

        formEncodedApi
            .post('/bulk-edit-person/apply.json', postData)
            .catch(() => {
                throw new Error('Something went wrong. Not everyone was removed from the audience');
            })
            .then(() => {
                this.props.onEdit();
            });
    };

    handleSyncToWebfxSubmit = (entityType: 'leads' | 'contacts') => {
        return (namedExport: string) => {
            const {massSelect, selectedItems, omittedItems, filters, search} = this.props;

            let postData: Record<string, any> = {};

            const defaultParams = {
                editType: 4,
                newFilters: true,
                meta: {
                    namedExport: namedExport,
                },
            } as const;
            if (massSelect) {
                postData = {
                    ...defaultParams,
                    filter: serializeFilters(filters),
                    q: search,
                    omittedItems: omittedItems,
                };
            } else {
                postData = {
                    ...defaultParams,
                    selectedIds: selectedItems,
                };
            }

            const endpoint =
                entityType === 'leads'
                    ? '/bulk-edit-lead/apply.json'
                    : '/bulk-edit-person/apply.json';

            return (
                formEncodedApi
                    .post(endpoint, postData)
                    // @ts-expect-error
                    .then((response) => response.json())
                    .then((responseJson) => {
                        if (
                            responseJson &&
                            responseJson.isValidationResult &&
                            !responseJson.isValid &&
                            responseJson.messages
                        ) {
                            throw new Error(responseJson.messages[0]);
                        }
                    })
                    .catch(() => {
                        throw new Error('Something went wrong. Could not sync to WebFX');
                    })
            );
        };
    };

    handleExportToMailChimp = (e: JQueryEventObject) => {
        e.preventDefault();
        this.props.onExportToMailChimp();
    };
}
